import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Form, Input, Button, Select, DatePicker } from 'antd'
import locale from 'antd/es/date-picker/locale/ru_RU'
import { userSelector } from '../../../store/session'
import useCategory from '../../hooks/useCategory'
import useProvider from '../../hooks/useProvider'
import ProjectSelector from '../../ProjectSelector'

const { RangePicker } = DatePicker

const dateFormat = 'DD.MM.YYYY'

const ApplicationFilter = ({ onSearch, filter }) => {
  const [form] = Form.useForm()
  const { user } = useSelector(userSelector)
  const [categories] = useCategory()
  const [providers] = useProvider()

  const initialFields = useMemo(
    () => Object.entries(filter).map(([key, value]) => ({ name: key, value: value })),
    [filter]
  )

  const onFormSubmit = (values) => {
    onSearch({
      id: values?.id,
      name: values?.name,
      categories: values?.categories || [],
      providers: values?.providers || [],
      projects: user?.projects?.filter((item) => values?.projects?.includes(item.id)).map((item) => item.id),
      dates: values?.dates?.map((item, index) => {
        if (index === 0) {
          return item.startOf('day').format('x')
        }
        return item.endOf('day').format('x')
      }),
      deliveryDates: values?.deliveryDates?.map((item, index) => {
        if (index === 0) {
          return item.startOf('day').format('x')
        }
        return item.endOf('day').format('x')
      }),
    })
  }

  const onClear = () => {
    form.resetFields()
    onSearch({
      id: null,
      name: '',
      categories: [],
      projects: [],
      dates: [],
      deliveryDates: [],
    })
  }

  return (
    <div style={{ padding: '5px 0px' }}>
      <Form fields={initialFields} form={form} layout="vertical" style={{ display: 'flex' }} onFinish={onFormSubmit}>
        <Form.Item style={{ width: 80 }} label="Номер" name="id">
          <Input allowClear />
        </Form.Item>
        <Form.Item style={{ marginLeft: 15, width: 180 }} label="Наименование" name="name">
          <Input allowClear />
        </Form.Item>
        <Form.Item style={{ marginLeft: 15, width: 200, maxWidth: 200 }} label="Категория" name="categories">
          <Select
            mode="multiple"
            allowClear
            options={categories.map((category) => ({
              value: category,
              label: category,
            }))}
            dropdownMatchSelectWidth={false}
          />
        </Form.Item>
        <Form.Item style={{ marginLeft: 15, width: 200, maxWidth: 200 }} label="Поставщик" name="providers">
          <Select
            mode="multiple"
            allowClear
            options={providers.map((provider) => ({
              value: provider,
              label: provider,
            }))}
            dropdownMatchSelectWidth={false}
          />
        </Form.Item>
        <Form.Item style={{ marginLeft: 15, width: 200, maxWidth: 200 }} label="Проект" name="projects">
          <ProjectSelector mode="multiple" />
        </Form.Item>
        <Form.Item label="Даты заявки" style={{ marginLeft: 15, maxWidth: 240 }} name="dates">
          <RangePicker locale={locale} format={dateFormat} />
        </Form.Item>
        <Form.Item label="Даты приемки" style={{ marginLeft: 15, maxWidth: 240 }} name="deliveryDates">
          <RangePicker locale={locale} format={dateFormat} />
        </Form.Item>
        <Form.Item label="" style={{ marginLeft: 15, marginTop: 30 }}>
          <Button onClick={() => form.submit()}>Применить</Button>
        </Form.Item>
        <Form.Item label="" style={{ marginLeft: 15, marginTop: 30 }}>
          <Button type="dashed" onClick={onClear}>
            Очистить
          </Button>
        </Form.Item>
      </Form>
    </div>
  )
}

export default ApplicationFilter
